import React, { createContext, useState, useEffect, useContext } from "react";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [refreshToken, setRefreshToken] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  // This effect checks for existing values in localStorage on initial load
  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    const storedRefreshToken = localStorage.getItem("refreshToken");
    const storedUser = JSON.parse(localStorage.getItem("user"));

    // Ensure all required values are present
    if (storedToken && storedRefreshToken && storedUser) {
      setUser(storedUser);
      setToken(storedToken);
      setRefreshToken(storedRefreshToken);
      setIsAuthenticated(true);
    }

    // Ensure loading is set to false after all state updates
    setLoading(false);
  }, []);

  // Login method to save to localStorage
  const login = (data) => {
    setUser(data.user);
    setToken(data.token);
    setRefreshToken(data.refreshToken);
    setIsAuthenticated(true);

    // Save user, token, and refreshToken in local storage
    localStorage.setItem("token", data.token);
    localStorage.setItem("refreshToken", data.refreshToken);
    localStorage.setItem("user", JSON.stringify(data.user));
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");
    sessionStorage.removeItem("couponCode");

    setUser(null);
    setToken(null);
    setRefreshToken(null);
    setIsAuthenticated(false);

    // Ensure loading is set to false after logout
    setLoading(false);
  };

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "token" && !e.newValue) window.location.href = "/";

      if (
        (e.key === "token" || e.key === "refreshToken" || e.key === "user") &&
        e.newValue
      ) {
        console.log("login", e.newValue);
        const currentAuthState = {
          token: localStorage.getItem("token"),
          refreshToken: localStorage.getItem("refreshToken"),
          user: JSON.parse(localStorage.getItem("user") || "null"),
        };
        if (
          currentAuthState.token &&
          currentAuthState.refreshToken &&
          currentAuthState.user
        ) {
          window.location.href = "/";
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  // Show loading state until data is loaded
  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <AuthContext.Provider
      value={{ user, token, refreshToken, isAuthenticated, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export { AuthContext, AuthProvider, useAuth };
